import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/header';

const congresso = require('../../assets/congresso.jpg');

export default function Documentarios() {
    const navigate = useNavigate();
    const handleTransition = (route) => {
        setTimeout(() => { navigate(route); }, 1000);
    };

    const episodios = Array.from({ length: 9 }, (_, i) => i + 1);

    return (
        <div>
            <Header show={false} cor='preto' />

            <style>{`
                @keyframes fadeInRight {
                    from { opacity: 0; transform: translateX(-50px); }
                    to   { opacity: 1; transform: translateX(0); }
                }
                .fade-in-right { animation: fadeInRight 1s ease-out forwards; }
                .ep-link { transition: color 0.5s ease-out, padding-top 0.5s ease-out; }
                .ep-link:hover { padding-top: 7px; color: #91917e; }
            `}</style>

            <div
                className="w-full h-screen bg-cover bg-center"
                style={{ backgroundImage: `url(${congresso})` }}
            >
                <div className="w-full h-full flex items-center justify-center" style={{ background: 'rgba(95,95,84,0.5)' }}>
                    <div className="flex flex-col text-white px-[5vw]">

                        {/* Título */}
                        <span className="fade-in-right font-futura-bold text-3xl md:text-[48px] mb-[-10px] md:mb-[-20px]">
                            DOCUMENTÁRIOS
                        </span>

                        {/* Episódios */}
                        <div className="flex items-start gap-2 md:gap-4 h-auto md:h-[15vh] mt-2">
                            <div className="fade-in-right font-light text-base md:text-[34px] text-right text-white pt-2 md:pt-[15px] w-[25vw] md:w-[15vw] tracking-widest flex justify-end leading-tight">
                                EPISÓDIOS
                            </div>
                            <div className="flex gap-1 md:gap-2 flex-wrap">
                                {episodios.map(numero => (
                                    <span
                                        key={numero}
                                        className="ep-link font-futura-bold text-3xl md:text-[68px] cursor-pointer px-1 md:px-2"
                                        style={{ color: '#bebea5', height: 'fit-content' }}
                                        onClick={() => handleTransition(`/episodios/${numero}`)}
                                    >
                                        {numero}
                                    </span>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}